import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const ForecastsPLGridPage = lazy(() => import('@/pages/forecasts-pl'));

export const forecastsPLRoutes: RouteConfig = {
  path: '/forecastsPL',
  layout: DashboardLayout,
  element: ForecastsPLGridPage,
};
